import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'textOverflow',
    standalone: true
})
export class TextOverflowPipe implements PipeTransform {

    transform(text: string, maxLength = 46): string {
        if (!text) {
            return '';
        }
        return text.length - 2 > maxLength
            ? text.substring(0, maxLength) + '(...)'
            : text;

    }
}
